/**
 * Source: Figma "RM V2 Library (MUI v7.2.0)" — Theme page, `Autocomplete` frame, `Shadows` group.
 * https://www.figma.com/design/kMeScGRhmLq2l22M2ZkmiE/RM-V2-Library--MUI-v7.2.0-?node-id=11207-164308
 *
 * Eight elevation tiers (Shadow 1 – Shadow 8), each a two-layer box-shadow:
 * a tight ambient layer at 4% black and a softer, negatively-spread direct
 * layer at 6% black. Values are the literal CSS sync'd from the Figma Shadows
 * frame — kept as raw strings since the per-tier offsets/blur don't follow a
 * single formula.
 *
 * MUI requires a 25-element shadow array (index 0 = "none", 1–24 = elevation
 * tiers); `createRmhTheme` distributes these 8 tiers across the lower slots.
 */
export const designShadows = {
  1: "0 1px 1px 0 rgba(0, 0, 0, 0.04), 1px 2px 4px -1px rgba(0, 0, 0, 0.06)",
  2: "1px 1px 2px 0 rgba(0, 0, 0, 0.04), 1px 3px 6px -1px rgba(0, 0, 0, 0.06)",
  3: "1px 2px 3px 0 rgba(0, 0, 0, 0.04), 1px 4px 8px -1px rgba(0, 0, 0, 0.06)",
  4: "1px 4px 6px 0 rgba(0, 0, 0, 0.04), 1px 5px 10px -1px rgba(0, 0, 0, 0.06)",
  5: "2px 6px 8px 0 rgba(0, 0, 0, 0.04), 2px 8px 12px -1px rgba(0, 0, 0, 0.06)",
  6: "2px 8px 10px 0 rgba(0, 0, 0, 0.04), 3px 10px 14px -1px rgba(0, 0, 0, 0.06)",
  7: "2px 10px 12px 0 rgba(0, 0, 0, 0.04), 3px 12px 16px -1px rgba(0, 0, 0, 0.06)",
  8: "3px 12px 16px 0 rgba(0, 0, 0, 0.04), 4px 16px 20px -1px rgba(0, 0, 0, 0.06)",
} as const;
